<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <h4 class="card-title">Basis gegevens</h4>
        <ValidationProvider
          name="firstName"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Voornaam</label>
            <md-input v-model="firstName" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="lastNamePrefix"
          rules="min:0|max:10"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Tussenvoegsel</label>
            <md-input v-model="lastNamePrefix" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="lastName"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Achternaam</label>
            <md-input v-model="lastName" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="email"
          rules="required|email"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>email</md-icon>
            <label>E-mailadres</label>
            <md-input v-model="email" type="email"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="password"
          rules="min:8"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>security</md-icon>
            <label>Wachtwoord</label>
            <md-input v-model="password" type="password"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="confirmPassword"
          rules="confirmed:password"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>security</md-icon>
            <label>Bevestig wachtwoord</label>
            <md-input v-model="confirmPassword" type="password"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <!-- begin field groups -->
      <template v-if="everythingLoaded">
        <md-card-content
          v-for="(fieldGroup, fieldGroupIndex) in fieldGroups"
          :key="fieldGroupIndex"
        >
          <h4 class="card-title">{{ fieldGroup.name }}</h4>
          <template
            v-for="(field, fieldIndex) in fieldsInGroup(fieldGroup['id'])"
          >
            <driver-edit-files
              v-if="fieldTypes[field['type_id']]['type'] === 'files'"
              :key="fieldIndex"
              :field-name="field.name"
              :field-id="field['id']"
              :content-types="
                fieldTypes[field['type_id']]['validation']['frontend'][
                  'content_type'
                ]
              "
            ></driver-edit-files>
            <template
              v-else-if="
                fieldTypes[field['type_id']]['type'] ===
                  'geocoder-distance-route-driver'
              "
            >
              <drivers-edit-distance-to-routes
                :key="fieldIndex"
                :field="field"
                :field-type="fieldTypes[field['type_id']]"
                :driver-lat="driverLat"
                :driver-lng="driverLng"
                v-model="fieldValues[field.id]['value']"
              ></drivers-edit-distance-to-routes>
            </template>
            <template
              v-else-if="
                fieldTypes[field['type_id']]['type'] === 'gecoder' ||
                  fieldTypes[field['type_id']]['type'] === 'gecoder-map'
              "
            >
              <ValidationProvider
                :name="field.id"
                :rules="fieldTypes[field['type_id']]['validation']['frontend']"
                v-slot="{ passed, failed }"
                :key="fieldIndex"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>input</md-icon>
                  <label>{{ field.name }}</label>
                  <geocoder
                    v-model="fieldValues[field.id]['value']"
                    :value="fieldValues[field.id]['value']"
                  ></geocoder>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
              <span
                :key="fieldIndex + 'map'"
                class="container-map-click-location"
              >
                <map-click-location
                  v-if="
                    fieldValues[field.id]['value']['lat'] &&
                      fieldValues[field.id]['value']['lng']
                  "
                  style="height: 250px; width: 100%;"
                  v-model="fieldValues[field.id]['value']"
                  :value="fieldValues[field.id]['value']"
                  marker="marker-driver.png"
                ></map-click-location>
              </span>
            </template>
            <ValidationProvider
              v-else
              :name="field.id"
              :rules="fieldTypes[field['type_id']]['validation']['frontend']"
              v-slot="{ passed, failed }"
              :key="fieldIndex"
            >
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'text'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-input
                  v-model="fieldValues[field.id]['value'][0]"
                  type="text"
                >
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'textarea'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-textarea
                  v-model="fieldValues[field.id]['value'][0]"
                ></md-textarea>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'date'"
                class="md-datepicker"
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <label>{{ field.name }}</label>
                <md-datepicker
                  v-model="fieldValues[field.id]['value'][0]"
                  :name="field.id"
                  :id="field.id"
                  :md-model-type="String"
                  md-immediately
                  :disabled="true"
                />
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="fieldTypes[field['type_id']]['type'] === 'select'"
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-select
                  v-model="fieldValues[field.id]['value'][0]"
                  :name="field.id"
                  :id="field.id"
                  required
                  :disabled="requesting"
                >
                  <md-option
                    v-for="(orderOption, index) in fieldTypes[field['type_id']][
                      'data'
                    ]['options']"
                    :value="orderOption['value']"
                    :key="index"
                    >{{ orderOption["label"] }}</md-option
                  >
                </md-select>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
              <md-field
                v-if="
                  fieldTypes[field['type_id']]['type'] === 'select-multiple'
                "
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>input</md-icon>
                <label>{{ field.name }}</label>
                <md-select
                  v-model="fieldValues[field.id]['value']"
                  :name="field.id"
                  :id="field.id"
                  required
                  :disabled="requesting"
                  multiple
                >
                  <md-option
                    v-for="(orderOption, index) in fieldTypes[field['type_id']][
                      'data'
                    ]['options']"
                    :value="orderOption['value']"
                    :key="index"
                    >{{ orderOption["label"] }}</md-option
                  >
                </md-select>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </template>
        </md-card-content>
      </template>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
        >
          Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
        >
          Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import DriverEditFiles from "./DriverEditFiles.vue";
import geocoder from "../../../components/OpenStreetMap/InputGeocoder";
import MapClickLocation from "../../../components/OpenStreetMap/MapClickLocation.vue";
import DriversEditDistanceToRoutes from "./DriversEditDistanceToRoutes.vue";

export default {
  components: {
    SlideYDownTransition,
    DriverEditFiles,
    geocoder,
    MapClickLocation,
    DriversEditDistanceToRoutes
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      firstName: "",
      lastNamePrefix: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      fields: [],
      fieldGroups: [],
      fieldTypes: {},
      fieldValues: [],
      touched: {
        firstName: false,
        lastNamePrefix: false,
        lastName: false,
        email: false,
        password: false,
        confirmPassword: false,
        fieldValues: false
      },
      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },
        lastNamePrefix: {
          required: false,
          min: 0,
          max: 10
        },
        lastName: {
          required: true,
          min: 2
        },
        email: {
          required: true,
          email: true
        },
        password: {
          required: false,
          min: 8
        },
        confirmPassword: {
          required: true,
          confirmed: "password"
        }
      },
      submitErrors: "",
      loaded: {
        groups: false,
        fields: false,
        types: false,
        driver: false
      }
    };
  },
  methods: {
    init() {
      this.$material.locale.dateFormat = "dd-MM-yyyy";
      this.$material.locale.firstDayOfAWeek = 1;
      this.$material.locale.days = [
        "Zondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrijdag",
        "Zaterdag"
      ];
      this.$material.locale.shortDays = [
        "Zon",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vri",
        "Zat"
      ];
      this.$material.locale.shorterDays = ["Z", "M", "D", "W", "D", "V", "Z"];
      this.$material.locale.months = [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ];
      this.$material.locale.shortMonths = [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
      ];
      this.$material.locale.shorterMonths = [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
      ];

      this.loadFields();
      this.loadFieldTypes();
      this.loadFieldGroups();
      if (this.$route.params.id !== undefined) {
        this.loadDriver(this.$route.params.id);
        this.modelValidations.password.required = false;
        this.modelValidations.confirmPassword.required = false;
      } else {
        this.firstName = "";
        this.lastNamePrefix = "";
        this.lastName = "";
        this.email = "";
        this.password = "";
        this.confirmPassword = "";

        this.modelValidations.password.required = true;
        this.modelValidations.confirmPassword.required = true;

        setTimeout(this.resetTouched, 100);
      }
    },
    formatDate(date) {
      if (typeof date !== "string" || date === "") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    formatDateBack(date) {
      if (typeof date !== "string" || date === "") {
        return null;
      }
      date = date.split("-");
      if (date[2].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl + "drivers/" + (this.$route.params.id ?? ""),
          Object.assign({
            firstName: this.firstName,
            lastNamePrefix: this.lastNamePrefix,
            lastName: this.lastName,
            email: this.email,
            password: this.password !== "" ? this.password : undefined,
            confirmPassword:
              this.password !== "" ? this.confirmPassword : undefined
          })
        )
        .then(
          response => {
            if (this.$route.params.id !== undefined) {
              this.saveFieldValues();
            } else {
              this.notifyVue(
                "Chauffeur succesvol toegevoegd",
                "check",
                "success",
                5000
              );
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    saveFieldValues() {
      let values = [];

      for (let i in this.fieldValues) {
        let value = this.fieldValues[i]["value"];
        let isOfTypeDate = this.isValueOfTypeDate(i);

        values.push({
          field_id: this.fieldValues[i]["field_id"],
          value: isOfTypeDate ? [this.formatDateBack(value[0])] : value
        });
      }

      this.$http
        .post(
          this.$apiBaseUrl + "drivers/field/values/" + this.$route.params.id,
          Object.assign({
            values: values
          })
        )
        .then(
          response => {
            this.password = "";
            this.confirmPassword = "";

            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Chauffeur succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan chauffeur",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadDriver(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "drivers/" + id).then(
        response => {
          this.firstName = response.data.driver.firstName;
          this.lastNamePrefix = response.data.driver.lastNamePrefix;
          this.lastName = response.data.driver.lastName;
          this.email = response.data.driver.email;
          this.password = "";
          this.confirmPassword = "";

          let fieldValues = {};
          for (let i in response.data.driver.fieldValues) {
            fieldValues[response.data.driver.fieldValues[i]["field_id"]] =
              response.data.driver.fieldValues[i];
          }

          for (let i in this.fields) {
            if (fieldValues[this.fields[i]["id"]] !== undefined) {
              continue;
            }

            fieldValues[this.fields[i]["id"]] = {
              user_id: this.$route.params.id,
              field_id: this.fields[i]["id"],
              id: null,
              value: [""]
            };
          }
          this.fieldValues = fieldValues;

          if (this.loaded.fields === true && this.loaded.types === true) {
            this.reformatWhenLoaded();
          }
          this.loaded.driver = true;

          setTimeout(this.resetTouched, 100);
          this.requesting = false;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van chauffeurs", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadFields() {
      this.$http.get(this.$apiBaseUrl + "drivers/fields").then(
        response => {
          this.fields = response.data.fields;

          for (let i in this.fields) {
            if (this.fieldValues[this.fields[i]["id"]] !== undefined) {
              continue;
            }

            this.fieldValues[this.fields[i]["id"]] = {
              field_id: this.fields[i]["id"],
              id: "",
              value: [""]
            };
          }

          if (this.loaded.types === true && this.loaded.driver === true) {
            this.reformatWhenLoaded();
          }
          this.loaded.fields = true;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "fields", "order"],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur velden",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadFieldGroups() {
      this.$http.get(this.$apiBaseUrl + "drivers/field/groups").then(
        response => {
          this.fieldGroups = response.data.fieldGroups;
          this.loaded.groups = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur veld groepen",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadFieldTypes() {
      this.$http.get(this.$apiBaseUrl + "drivers/field/types").then(
        response => {
          let fieldTypes = {};
          for (let i in response.data.fieldTypes) {
            fieldTypes[response.data.fieldTypes[i]["id"]] =
              response.data.fieldTypes[i];

            if (
              fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
                "frontend"
              ]["regex"] === undefined
            ) {
              continue;
            }

            fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
              "frontend"
            ]["regex"] = new RegExp(
              fieldTypes[response.data.fieldTypes[i]["id"]]["validation"][
                "frontend"
              ]["regex"]
            );
          }

          this.fieldTypes = fieldTypes;

          if (this.loaded.fields === true && this.loaded.driver === true) {
            this.reformatWhenLoaded();
          }
          this.loaded.types = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van Chauffeur veld typen",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    reformatWhenLoaded() {
      for (let f in this.fields) {
        if (this.fieldTypes[this.fields[f]["type_id"]]["type"] === "date") {
          this.fieldValues[this.fields[f]["id"]]["value"][0] = this.formatDate(
            this.fieldValues[this.fields[f]["id"]]["value"][0]
          );
        }
      }
    },
    isValueOfTypeDate(valueId) {
      for (let f in this.fields) {
        if (this.fields[f]["id"] !== valueId) {
          continue;
        }

        if (this.fieldTypes[this.fields[f]["type_id"]]["type"] === "date") {
          return true;
        }

        return false;
      }
    },
    resetTouched() {
      this.touched.firstName = false;
      this.touched.lastNamePrefix = false;
      this.touched.lastName = false;
      this.touched.email = false;
      this.touched.fieldValues = false;
    },
    showSwal() {
      Swal.fire({
        title: "Waarschuwing!",
        text: "Weet u zeker dat u de wijzigingen wilt negeren?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, ga terug zonder op te slaan",
        cancelButtonText: "Annuleren",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$router.go(-1);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    fieldsInGroup(groupId) {
      let data = [];

      for (let i in this.fields) {
        if (this.fields[i]["group_id"] !== groupId) {
          continue;
        }

        data.push(this.fields[i]);
      }

      return data;
    }
  },
  watch: {
    firstName() {
      if (!this.requesting) {
        this.touched.firstName = true;
      }
    },
    lastNamePrefix() {
      if (!this.requesting) {
        this.touched.lastNamePrefix = true;
      }
    },
    lastName() {
      if (!this.requesting) {
        this.touched.lastName = true;
      }
    },
    email() {
      if (!this.requesting) {
        this.touched.email = true;
      }
    },
    password() {
      if (!this.requesting) {
        this.touched.password = true;
      }
    },
    confirmPassword() {
      if (!this.requesting) {
        this.touched.confirmPass = true;
      }
    },
    fieldValues: {
      handler: function(val, oldVal) {
        this.touched.fieldValues = true;
      },
      deep: true
    },
    geocoder: {
      handler(val) {
        // console.log("geocoder changed!");
        if (!this.requesting) {
          this.touched.geocoder = true;
        }
      },
      deep: true
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Chauffeur bewerken";
      }
      return "Chauffeur toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "person";
      }
      return "person_add";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    driverLatLng: function() {
      for (let fieldTypeId in this.fieldTypes) {
        if (
          this.fieldTypes[fieldTypeId]["type"] != "gecoder" &&
          this.fieldTypes[fieldTypeId]["type"] != "gecoder-map"
        ) {
          continue;
        }

        for (let fieldIndex in this.fields) {
          if (
            this.fields[fieldIndex]["type_id"] !=
            this.fieldTypes[fieldTypeId]["id"]
          ) {
            continue;
          }

          return this.fieldValues[this.fields[fieldIndex]["id"]]["value"];
        }
      }

      return "";
    },
    driverLat: function() {
      if (this.driverLatLng["lat"]) {
        return this.driverLatLng["lat"];
      }

      return "";
    },
    driverLng: function() {
      if (this.driverLatLng["lng"]) {
        return this.driverLatLng["lng"];
      }

      return "";
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
.md-card-content > span > .md-field.md-datepicker {
  padding-top: 15px;
  &:after {
    bottom: 20px;
  }
}

.container-map-click-location > div {
  padding-bottom: 10px;
}
</style>
<style lang="css">
.md-menu.md-select:not(.md-disabled) .md-icon,
.md-menu.md-select:not(.md-disabled) .md-input {
  margin-left: 12px;
}
</style>
